// Ajax cart JS for Drawer and Cart Page
class quickShop extends HTMLElement {
  constructor() {
    super();

    this.closeBy = this.querySelector(".close-quickshop");
    setTimeout(() => {
      this.bindEvents();
    }, 5000);
    this.updateEvents();

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
  }

  componentProductForm() {
    /**
     * Limit the number of times a function is called within defined timeout
     *
     * @param {form} form - Form to serialize
     */
    const serializeForm = (form) => {
      const obj = {};
      const formData = new FormData(form);

      for (const key of formData.keys()) {
        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
        if (regex.test(key)) {
          obj.properties = obj.properties || {};
          obj.properties[regex.exec(key)[2]] = formData.get(key);
        } else {
          obj[key] = formData.get(key);
        }
      }

      return JSON.stringify(obj);
    };

    let product_json = document.querySelector(
      "form[data-product-form] [data-productJSON]"
    );
    let productDataParse = JSON.parse(product_json.textContent),
      varintInventory = productDataParse.inventory_quantity;
    let productTitle = productDataParse.product.title,
      productId = productDataParse.product.id,
      productCurrentPrice = productDataParse.product.variants[0].price,
      productPublicTitle = productDataParse.product.variants[0].public_title,
      productVariantID = productDataParse.product.variants[0].id,
      quantity = 1,
      currentProductVariant = false,
      options_length = false;

    const form_inputs = document.querySelectorAll(
      "[data-product-form] .product_option input,.product-details-wrapper [data-product-form] .product_option select"
    );
    let addBtn = document
      .querySelector("form[data-product-form]")
      .querySelector('[name="add"]');
    let productStatus;

    /**
     * Product Form Components
     *
     */

    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartElement = document.querySelector("ajax-cart");

        this.qtyBtns = this.querySelectorAll("[data-qty-btn]");
        this.qtyBtns.forEach((qtyBtn) =>
          qtyBtn.addEventListener("click", this.manageQtyBtn.bind(this))
        );
        this.qtyInputElement = this.querySelector("[data-qty-input]");

        if (
          productDataParse.product.tags.includes(
            "laser-engraved-lacrosse-bulk-ball"
          )
        ) {
          this.qtyInputElement.value = 24;
        }
        if (this.qtyInputElement) {
          this.qtyInputElement.addEventListener("change", function () {
            if (
              parseInt(this.value) <= 0 ||
              this.value == undefined ||
              this.value == null ||
              this.value == ""
            ) {
              this.value = 1;
            }

            let qtyFlag = manage_inventory(this.value);
            if (qtyFlag) {
              this.value = 1;
              return false;
            }
            quantity_update(parseInt(this.value));
          });
        }
      }

      /**
       * Product Form Submit event
       *
       * @param {evt} Event instance
       */
      async onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        const qtyInput = this.querySelector("[data-qty-input]");

        let qtyFlag = await manage_inventory(qtyInput.value);
        if (qtyFlag) {
          return false;
        }

        dataLayer.push({
          ecommerce: null,
        }); // Clear the previous ecommerce object.
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            value: `${Shopify.formatMoney(
              productCurrentPrice,
              window.globalVariables.money_format
            )}`,
            items: [
              {
                item_name: `${productTitle}`, // Name or ID is required.
                item_id: `${productId}`,
                price: `${Shopify.formatMoney(
                  productCurrentPrice,
                  window.globalVariables.money_format
                )}`,
                item_variant: `${productPublicTitle}`,
                item_variant_id: `${productVariantID}`,
                quantity: quantity,
              },
            ],
          },
        });

        submitButton.setAttribute("disabled", true);
        submitButton.querySelector(".add-text").textContent = "Please Wait...";

        let body = JSON.parse(serializeForm(this.form));

        if (
          productDataParse.product.tags.includes(
            "laser-engraved-lacrosse-bulk-ball"
          )
        ) {
          let fileUpload = document.querySelector(
            "[data-textfield_your-logo]"
          ).files;
          var myHeaders = new Headers();
          myHeaders.append("Accept", "application/json");

          var formdata = new FormData();
          formdata.append("logo", fileUpload[0], fileUpload[0].name);

          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          };

          let imageURL = function (options) {
            return new Promise((resolve, reject) => {
              fetch(
                "https://code.hulkapps.com/sportstop-script/api/store/lacrosse",
                options
              )
                .then((response) => response.json())
                .then((data) => {
                  resolve(data.url);
                })
                .catch((error) => {
                  console.log("error", error);
                  reject();
                });
            });
          };

          const yourLogo = await imageURL(requestOptions);
          // document.querySelector(".hidden_img").setAttribute("value",yourLogo);
          delete body.yourlogo;
          body = {
            ...body,
            properties: {
              ...body.properties,
              "Your Logo": yourLogo,
            },
          };
        }

        body = JSON.stringify(body);

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig("javascript"),
          body,
        })
          .then((response) => response.json())
          .then((parsedState) => {
            this.cartElement.getCartData("open_drawer");
            if (qtyInput) qtyInput.value = 1;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.querySelector(".add-text").textContent = "Add To cart";
            submitButton.removeAttribute("disabled");
            document.getElementById("quickshop-modal").classList.remove("open");
          });
      }

      /**
       * Product Form Quantity Input update action
       *
       * @param {event} Event instance
       */
      async manageQtyBtn(event) {
        event.preventDefault();

        let currentTarget = event.currentTarget;
        let action = currentTarget.dataset.for || "increase";
        let $qtyInput = currentTarget
          .closest("[data-qty-container]")
          .querySelector("[data-qty-input]");
        let currentQty = parseInt($qtyInput.value) || 1;
        let finalQty = 1;

        if (action == "decrease" && currentQty <= 1) {
          return false;
        } else if (action == "decrease") {
          finalQty = currentQty - 1;
        } else {
          finalQty = currentQty + 1;
        }

        if (
          productDataParse.product.tags.includes(
            "laser-engraved-lacrosse-bulk-ball"
          ) &&
          finalQty < 24
        ) {
          finalQty = 24;
        }

        if (action != "decrease") {
          let qtyFlag = await manage_inventory(finalQty);
          if (qtyFlag) {
            return false;
          }
        }

        $qtyInput.value = finalQty;
        quantity = finalQty;
        quantity_update(finalQty);
      }
    }
    customElements.define("product-form-quickadd", ProductForm);

    class VariantSelects extends HTMLElement {
      constructor() {
        super();

        this.form = this.closest("form");
        if (this.form == null || window.globalVariables.template == "product")
          this.form = document.querySelector(
            ".product-details-wrapper [data-product-form]"
          );
        this.formType = this.form.dataset.format;
        this.addBtn = this.form.querySelector('[name="add"]');
        this.variant_json = this.form.querySelector("[data-variantJSON]");
        this.NotifyMeBtn = document.querySelector("#BIS_trigger");
        this.productVariants = [];
        this.flagSoldOut = false;

        this.variantPicker = this.dataset.type;

        let url = window.location.search;
        if (url.indexOf("variant=") === -1) {
          this.querySelectorAll(".variant_selector").forEach((selector) => {
            selector.selectedIndex = "0";
          });
        }

        // if (this.formType == 'product-page') this.onVariantChange("load");
        // if (this.formType == 'quickshop') this.onVariantChange("load");
        this.addEventListener("change", this.onVariantChange);

        productDataParse.product.variants.forEach((variant) => {
          if (variant.available) {
            this.productVariants.push(variant);
          } else {
            this.flagSoldOut = true;
          }
        });

        if (this.flagSoldOut === true) {
          this.NotifyMeBtn.classList.remove("d-none");
        }

        if (this.productVariants.length > 0) {
          let proVariants = this.productVariants;

          new Promise(function (myResolve, myReject) {
            proVariants.forEach((variant) => {
              const variantValue = Utility.handleize(variant.title);
              let dataOptions_1 = document.querySelectorAll(
                "[data-product-options-1] [data-single-option-selector] option"
              );
              dataOptions_1.forEach((ele) => {
                const value = Utility.handleize(ele.value);
                if (variantValue === value) {
                  ele.classList.add("availableShow");
                  ele.classList.remove("hideVariant");
                }
              });

              let dataOptions_2 = document.querySelectorAll(
                '[data-product-options-2] [data-index="option1"] option, [data-product-options-3] [data-index="option1"] option'
              );
              dataOptions_2.forEach((ele) => {
                const value = Utility.handleize(ele.value);
                const variantNew1 = Utility.handleize(
                  variant.title.split(" / ")[0]
                );
                if (variantNew1 === value) {
                  ele.classList.add("availableShow");
                  ele.classList.remove("hideVariant");
                }
              });

              let dataOptions_3 = document.querySelectorAll(
                '[data-product-options-2] [data-index="option2"] option, [data-product-options-3] [data-index="option2"] option'
              );
              dataOptions_3.forEach((ele) => {
                const value = Utility.handleize(ele.value);
                const variantNew2 = Utility.handleize(
                  variant.title.split(" / ")[1]
                );
                if (variantNew2 === value) {
                  ele.classList.add("availableShow");
                  ele.classList.remove("hideVariant");
                }
              });

              let dataOptions_4 = document.querySelectorAll(
                '[data-product-options-2] [data-index="option3"] option, [data-product-options-3] [data-index="option3"] option'
              );
              dataOptions_4.forEach((ele) => {
                const value = Utility.handleize(ele.value);
                const variantNew2 = Utility.handleize(
                  variant.title.split(" / ")[2]
                );
                if (variantNew2 === value) {
                  ele.classList.add("availableShow");
                  ele.classList.remove("hideVariant");
                }
              });
            });
            myResolve(); // when successful
          }).then(function () {
            document.querySelectorAll(".hideVariant").forEach((ele) => {
              ele.remove();
            });
          });
        }
      }

      onVariantChange() {
        this.setCurrentVariant();
        currentProductVariant = this.currentVariant;
        this.currentVariant_inventory = varintInventory.filter(
          (response) => parseInt(response.id) === currentProductVariant.id
        );
        if (!this.currentVariant && productDataParse.product.available) {
          toggleAddButton("disable", this.addBtn, this.currentVariant);
        } else {
          productCurrentPrice = this.currentVariant.price;
          productPublicTitle = this.currentVariant.public_title;
          productVariantID = this.currentVariant.id;

          if (this.formType == "grid") {
            const productGrid = this.closest("[data-product-grid]");
            this.renderProductInfo(this.currentVariant, productGrid);
            this._updateLinks(productGrid);
          } else {
            const productPage = this.closest("[data-product-container]");
            this.renderProductInfo(this.currentVariant, productPage);
          }
          this.updateURLandID(this.currentVariant);
          optionToggle(this.currentVariant);
          this.updateVariantInput();
        }
      }

      _updateLinks(productGrid) {
        if (!this.currentVariant || !productGrid) return;
        const variantURL = "?variant=" + this.currentVariant.id;
        const formLinks = productGrid.querySelectorAll(".product-link");
        formLinks.forEach((link) => {
          let href = link.href.split("?")[0];
          link.href = href + variantURL;
        });
      }

      _getOptionsFromSelect() {
        console.log("optionss----");
        let options = [];
        this.querySelectorAll(".variant_selector").forEach((selector) => {
          options.push(selector.value);
        });
        return options;
      }

      _getOptionsFromRadio() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        const options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value;
        });
        return options;
      }

      setCurrentVariant() {
        // get all current values from selectors
        this.currentVariant = false;
        let options =
          this.variantPicker == "variant-select"
            ? this._getOptionsFromSelect()
            : this._getOptionsFromRadio();

        if (!options.includes("")) {
          options_length = true;
        }

        let variantsArray = this._getVariantData();
        variantsArray.find((variant) => {
          // get true or false based on options value presented in variant
          // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
          let mappedValues = variant.options.map((option, index) => {
            return options[index] === option;
          });

          // assign variant details to this.currentVariant if all options are present
          if (!mappedValues.includes(false)) {
            this.currentVariant = variant;
            return;
          }
        });
      }

      updateURLandID(currentVariant) {
        if (!currentVariant) return;
        // update query string with latest variant ID
        if (this.formType == "product-page") {
          let newUrl = `${this.dataset.url}`;
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("variant", currentVariant.id);
          if (searchParams.toString()) newUrl += `?${searchParams.toString()}`;
          window.history.replaceState({}, "", newUrl);
        }
      }

      updateVariantInput() {
        // update variant input with currentVariant Id
        const productForms = document.querySelectorAll(
          `.product-form [data-product-form]`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        });
      }

      renderProductInfo(currentVariant, container) {
        if (!currentVariant || !container) return;

        // Price Update
        let price = Shopify.formatMoney(
          currentVariant.price,
          window.globalVariables.money_format
        );
        let compare_price = Shopify.formatMoney(
          currentVariant.compare_at_price,
          window.globalVariables.money_format
        );
        let priceElement = container.querySelector("[data-currentPrice]");
        let comparePriceElement = container.querySelector(
          "[data-comparePrice]"
        );
        // let varintInventory = productDataParse.inventory_quantity;
        // let inventory;

        if (
          window.customerString.customerAvailable === true &&
          window.customerString.customerTag === true
        ) {
          let teamFlag = false;
          let teamValue;
          productDataParse.product.tags.forEach((tag) => {
            if (tag.indexOf("team_fixed") > -1) {
              teamFlag = true;
              teamValue = tag.split("team_fixed_")[1];
            }
          });

          let discount_message = document.querySelector(
            ".product-details-wrapper .price-wrapper [data-discount]"
          );

          const classArray = [
            "h3",
            "actual-price",
            "font-family-base",
            "fw-bold",
            "text-primary",
            "ms-2",
          ];
          let span_obj = document.createElement("span");
          span_obj.setAttribute("data-discount", "");
          span_obj.classList.add(...classArray);
          compare_price = price;

          if (teamFlag === true) {
            let listPrice = price.replace("$", "");
            const varPrice = parseFloat(listPrice);
            let main = teamValue;
            main = main.replace("%", "");
            const discount = parseFloat(main);
            let calculate = (varPrice - (varPrice * discount) / 100).toFixed(2);
            price = Shopify.formatMoney(
              calculate,
              window.globalVariables.money_format
            );
            span_obj.innerHTML = "TEAM SPECIAL PRICE";
          } else {
            let main = price.replace("$", "");
            const priceVal = parseFloat(main);
            const dec = (5 / 100).toFixed(2); // its convert 10 into 0.10
            const mult = priceVal * dec; // gives the value for subtract from main value
            const discount = priceVal - mult.toFixed(2);
            price = Shopify.formatMoney(
              discount.toFixed(2),
              window.globalVariables.money_format
            );
            span_obj.innerHTML = "5% OFF TEAM DISCOUNT";
          }

          if (discount_message == null) {
            priceElement.parentNode.insertBefore(
              span_obj,
              priceElement.nextSibling
            );
            priceElement.classList.add("text-primary");
          }
        }

        if (priceElement) priceElement.innerHTML = price;
        if (comparePriceElement) comparePriceElement.innerHTML = compare_price;

        this._inventoryLimit();

        // Grid Image Update on variant selection
        if (this.formType == "grid") {
          if (!currentVariant.featured_image) return;
          const featuredImage = container.querySelector("[data-feauredImage]");
          let updatedSrc = currentVariant.featured_image.src;
          if (updatedSrc) {
            featuredImage.src = updatedSrc;
            featuredImage.srcset = updatedSrc;
          }
        } else {
          if (!currentVariant.featured_image) return;
          let imageID = currentVariant.featured_image.id;
          let imageSlide = document.querySelector(
            `.product--image[data-imageID="${imageID}"]`
          );
          if (!imageSlide) return;
          let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(
            imageSlide
          );
          if (productSlider) productSlider.slideTo(slideIndex, 1000, true);
        }

        // Variant name update
        let options = this.form.querySelectorAll("[data-optionindex]");
        options.forEach((option) => {
          let lableID = "option" + option.dataset.optionindex;
          const lable = option.querySelector(".selected-option");
          if (!lable || !lableID) return;
          lable.innerHTML = currentVariant[lableID];
        });
      }

      _getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.variant_json.textContent);
        return this.variantData;
      }

      _inventoryLimit() {
        let inventoryMsg = document.querySelector("[data-inventory-msg]");
        if (this.currentVariant_inventory.length) {
          if (
            this.currentVariant_inventory[0].inventory <= 0 &&
            this.currentVariant_inventory[0].inventory_management == "shopify"
          ) {
            inventoryMsg.querySelector(
              "span"
            ).innerHTML = `<strong>This Product variant is out of stock</strong>`;
            inventoryMsg.classList.remove("d-none");
          } else if (
            this.currentVariant_inventory[0].inventory > 0 &&
            this.currentVariant_inventory[0].inventory < 20 &&
            this.currentVariant_inventory[0].inventory_management == "shopify"
          ) {
            let lineItem = document.querySelectorAll("[data-cart-item]");
            let totalQuantity = this.currentVariant_inventory[0].inventory;
            let cartBoxQuantity = 0;

            lineItem.forEach((items) => {
              let itemID = items.getAttribute("data-variant-id");
              if (itemID == this.currentVariant_inventory[0].id) {
                cartBoxQuantity = items.querySelector("[data-qty-input]").value;
              }
            });
            if (this.currentVariant_inventory[0].inventory >= cartBoxQuantity) {
              totalQuantity =
                parseInt(this.currentVariant_inventory[0].inventory) -
                parseInt(cartBoxQuantity);
            }
            if (totalQuantity > 0) {
              inventoryMsg.querySelector(
                "span"
              ).innerHTML = `<strong>Only <span data-variant_inventory='${totalQuantity}'>${totalQuantity}</span> In Stock</strong>`;
            } else {
              inventoryMsg.querySelector(
                "span"
              ).innerHTML = `<strong>All ${this.currentVariant_inventory[0].inventory} Inventory added into the cart<strong>`;
            }
            inventoryMsg.classList.remove("d-none");
          } else {
            inventoryMsg.classList.add("d-none");
          }
        }
      }
    }
    customElements.define("variant-selects", VariantSelects);

    let product_url = window.location.search;
    if (product_url.indexOf("variant=") > -1) {
      let current_VariantjsonHTML = document.querySelector(
          "form[data-product-form] [data-selectedJSON]"
        ),
        current_Variantjson = JSON.parse(current_VariantjsonHTML.textContent);

      if (current_Variantjson) {
        currentProductVariant = current_Variantjson;
        let productVariants = document.querySelector(
          '[data-type="variant-select"]'
        );

        if (productVariants) {
          productVariants.currentVariant_inventory = varintInventory.filter(
            (response) => parseInt(response.id) === current_Variantjson.id
          );
          //  this.currentVariant_inventory = varintInventory.filter((response) => parseInt(response.id) === current_Variantjson.id);
          const productPage = productVariants.closest(
            "[data-product-container]"
          );
          productVariants.renderProductInfo(current_Variantjson, productPage);
        }
        optionToggle(current_Variantjson);
      }
    } else {
      optionToggle();
    }

    // other changes
    /* Disable and Enable Button on Variant change */
    function toggleAddButton(productStatus, addBtn, currentVariant) {
      // let NotifyMeBtn = document.querySelector("#BIS_trigger");

      if (!addBtn) return;
      if (!currentVariant && options_length == true) {
        addBtn.setAttribute("disabled", true);
        if (addBtn.querySelector(".add-text"))
          addBtn.querySelector(".add-text").textContent =
            window.variantStrings.unavailable;
        if (
          document.querySelector(
            ".product-details-wrapper [data-qty-container]"
          )
        )
          document
            .querySelector(".product-details-wrapper [data-qty-container]")
            .classList.add("opacity-apply");
        if (document.getElementsByClassName("item-details-add-to-cart-help")[0])
          document
            .getElementsByClassName("item-details-add-to-cart-help")[0]
            .classList.add("d-none");
        if (document.querySelector("[data-inventory-msg]"))
          document
            .querySelector("[data-inventory-msg]")
            .classList.add("d-none");
      } else if (productStatus == "disable") {
        addBtn.setAttribute("disabled", true);
        if (addBtn.querySelector(".add-text"))
          addBtn.querySelector(".add-text").textContent = "Select an option";
        if (
          document.querySelector(
            ".product-details-wrapper [data-qty-container]"
          )
        )
          document
            .querySelector(".product-details-wrapper [data-qty-container]")
            .classList.add("opacity-apply");
        if (document.getElementsByClassName("item-details-add-to-cart-help")[0])
          document
            .getElementsByClassName("item-details-add-to-cart-help")[0]
            .classList.remove("d-none");
      } else if (currentVariant && !currentVariant.available) {
        addBtn.setAttribute("disabled", true);
        if (addBtn.querySelector(".add-text"))
          addBtn.querySelector(".add-text").textContent =
            window.variantStrings.soldOut;
        if (
          document.querySelector(
            ".product-details-wrapper [data-qty-container]"
          )
        )
          document
            .querySelector(".product-details-wrapper [data-qty-container]")
            .classList.add("opacity-apply");
        if (document.getElementsByClassName("item-details-add-to-cart-help")[0])
          document
            .getElementsByClassName("item-details-add-to-cart-help")[0]
            .classList.add("d-none");
      } else {
        addBtn.removeAttribute("disabled");
        if (addBtn.querySelector(".add-text"))
          addBtn.querySelector(".add-text").textContent =
            window.variantStrings.addToCart;
        if (
          document.querySelector(
            ".product-details-wrapper [data-qty-container]"
          )
        )
          document
            .querySelector(".product-details-wrapper [data-qty-container]")
            .classList.remove("opacity-apply");
        if (document.getElementsByClassName("item-details-add-to-cart-help")[0])
          document
            .getElementsByClassName("item-details-add-to-cart-help")[0]
            .classList.add("d-none");
      }
    }

    function optionToggle(currentVariant) {
      productStatus = "";
      form_inputs.forEach((input) => {
        if (input.value == "") {
          productStatus = "disable";
        }
      });

      if (
        productDataParse.product.tags.includes(
          "laser-engraved-lacrosse-bulk-ball"
        )
      ) {
        let uploadImageBox = document.querySelector(
          "[data-textfield_your-logo]"
        );
        if (uploadImageBox.value != "") {
          let laserBallImageTag = document.querySelector("#myImg_laser_ball");
          if (laserBallImageTag.getAttribute("src") == "#") {
            productStatus = "disable";
          }
        }
      }

      if (productStatus != "disable" && currentVariant) {
        productStatus = "enable";
      }
      toggleAddButton(productStatus, addBtn, currentVariant);
    }

    if (form_inputs.length > 0) {
      let eventName = "change keyup";
      let events = eventName.split(" ");

      for (var i = 0; i < events.length; i++) {
        form_inputs.forEach((field) =>
          field.addEventListener(events[i], function () {
            if (this.type !== "file") {
              optionToggle(currentProductVariant);
            }
          })
        );
      }
    }

    /*Based on Quantity change discount price change */

    function quantity_update(qtyValue) {
      if (qtyValue) {
        let arrayTagsVD = [];
        productDataParse.product.tags.forEach((tag, index) => {
          if (tag.match("vd")) {
            arrayTagsVD.push(tag);
          }
        });

        var collator = new Intl.Collator(undefined, {
          numeric: true,
          sensitivity: "base",
        });
        arrayTagsVD = arrayTagsVD.sort(collator.compare);
        let vdDiscount = document.querySelector(
          ".product-details-wrapper [data-price-vd]"
        );
        let originalDiv = document.querySelector(
          ".product-details-wrapper [data-price-original]"
        );

        let hideShowFlag = false;
        arrayTagsVD.forEach((tag, index) => {
          const splitTag = tag.split("_");
          const rangeNumber = splitTag[1];
          const limitNumber = rangeNumber.split("-");

          if (qtyValue < limitNumber[0]) {
            return false;
          } else {
            hideShowFlag = true;
            let price = splitTag[2];
            price = Shopify.formatMoney(
              price,
              window.globalVariables.money_format
            );
            vdDiscount.innerHTML = `<i class="icon icon-save-money text-primary me-2" style="font-size: 30px;" data-vd-icon></i> ${price}`;
            vdDiscount.classList.remove("d-none");
            originalDiv.classList.add("d-none");
            return false;
          }
        });

        if (hideShowFlag == false) {
          originalDiv.classList.remove("d-none");
          vdDiscount.classList.add("d-none");
        }
      }
    }

    function manage_inventory(currentQty) {
      let currentVariant_inventory = varintInventory.filter(
        (response) => parseInt(response.id) === currentProductVariant.id
      );
      if (currentVariant_inventory.length == 0) {
        currentVariant_inventory = varintInventory;
      }
      let qtyFlag = false,
        variantInventory = currentVariant_inventory[0].inventory,
        cartBoxQuantity = 0,
        productBoxQuantity = currentQty,
        inventory = 0,
        inventory_management = currentVariant_inventory[0].inventory_management;

      let lineItem = document.querySelectorAll("[data-cart-item]");
      lineItem.forEach((items) => {
        let itemID = items.getAttribute("data-variant-id");
        if (itemID == currentVariant_inventory[0].id) {
          cartBoxQuantity = items.querySelector("[data-qty-input]").value;
        }
      });

      let totalQuantity =
        parseInt(cartBoxQuantity) + parseInt(productBoxQuantity);

      if (inventory_management == "shopify") {
        if (variantInventory >= totalQuantity) {
          inventory =
            parseInt(currentVariant_inventory[0].inventory) -
            parseInt(totalQuantity);
          qtyFlag = false;
        } else {
          inventory = 0;
          qtyFlag = true;
        }

        if (inventory == 0 && qtyFlag == true) {
          let notificationEle = document.querySelector("custom-notification");
          notificationEle.updateNotification(
            "Available quantity exceeded.",
            "Product Limit",
            {
              type: "warning",
              timeout: 10000,
            }
          );
        }
      }

      return qtyFlag;
    }

    if (document.querySelector("[data-textfield_your-logo]")) {
      async function _readURL(input, imageElement, extraFunction) {
        if (input.files && input.files[0]) {
          var reader = new FileReader();

          reader.onload = await function (e) {
            imageElement.setAttribute("src", e.target.result);
            imageElement.classList.remove("d-none");
            document
              .querySelector("[data-popup-img]")
              .setAttribute("src", e.target.result);

            if (extraFunction) extraFunction(currentProductVariant);
          };
          reader.readAsDataURL(input.files[0]);
        }
      }

      function lacrossBallPDP() {
        document.querySelector("[data-textfield_your-logo]").addEventListener(
          "change",
          (element) => {
            let $this = element.target;
            let imgElement = document.querySelector("#myImg_laser_ball");

            if (
              document.querySelector("[data-custom-options] .alert_error_ball")
            ) {
              $this.nextElementSibling.remove();
            }

            let regex = new RegExp("([a-zA-Z0-9s_\\.-:])+(.jpg|.jpeg)$");
            let fileUpload = $this.files;

            if ($this.value != "") {
              if (regex.test($this.value.toLowerCase())) {
                if (typeof fileUpload != "undefined") {
                  let image = new Image();
                  image.src = window.URL.createObjectURL(fileUpload[0]);

                  let fsize = fileUpload[0].size;
                  let imageSize = Math.round(fsize / 1024);

                  image.onload = function () {
                    let width = this.width;
                    let maxSize = parseInt(3072);

                    if (imageSize >= maxSize) {
                      let span_obj =
                        "<span class='text-danger alert alert-danger alert_error_ball'><b>Image Size</b> should be <b>Less than 3MB</b></span>";
                      $this.insertAdjacentHTML("afterend", span_obj);
                      imgElement.classList.add("d-none");
                      imgElement.src = "#";
                      optionToggle(currentProductVariant);
                      return false;
                    }

                    if (width < 400) {
                      let span_obj =
                        "<span class='text-danger alert alert-danger alert_error_ball'><b>Minimum Width</b> should be <b>400 pixels</b></span>";
                      $this.insertAdjacentHTML("afterend", span_obj);
                      imgElement.classList.add("d-none");
                      imgElement.src = "#";
                      optionToggle(currentProductVariant);
                      return false;
                    }

                    _readURL($this, imgElement, optionToggle);
                    return true;
                  };
                } else {
                  let span_obj =
                    "<span class='text-danger alert alert-danger alert_error_ball'>This browser does not support HTML5.</span>";
                  $this.insertAdjacentHTML("afterend", span_obj);
                  imgElement.classList.add("d-none");
                  imgElement.src = "#";
                  return false;
                }
              } else {
                let span_obj =
                  "<span class='text-danger alert alert-danger alert_error_ball'>Please select a <b>Jpg or Jpeg</b> file format.</span>";
                $this.insertAdjacentHTML("afterend", span_obj);
                imgElement.classList.add("d-none");
                imgElement.src = "#";
                optionToggle(currentProductVariant);
                return false;
              }
            } else {
              let span_obj =
                "<span class='text-danger alert alert-danger alert_error_ball'>Please select an Image.</span>";
              $this.insertAdjacentHTML("afterend", span_obj);
              imgElement.classList.add("d-none");
              imgElement.src = "#";
              optionToggle(currentProductVariant);
              return false;
            }
          },
          false
        );

        document
          .querySelector("[data-change-image]")
          .addEventListener("click", function () {
            document.querySelector("#ModalClose-LaserBallImageModal").click();
            document.querySelector("[data-textfield_your-logo]").click();
          });
      }

      lacrossBallPDP();
    }
  }
  /**
   * Escape Click event to close drawer when focused within Cart Drawer
   *
   * @param {event} Event instance
   */
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.querySelector(".close-quickshop").dispatchEvent(new Event("click"));
  }

  /**
   * bind click and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
   */
  bindEvents() {
    this.openeBy = document.querySelectorAll(".quickshop--button");
    this.openeBy.forEach((btn) =>
      btn.addEventListener("click", this.openQuickShop.bind(this))
    );
    this.addEventListener("keyup", this.onKeyUp.bind(this));
  }

  updateEvents() {
    this.openeBy = document.querySelectorAll(".quickshop--button");
    if (this.openeBy)
      this.openeBy.forEach((btn) =>
        btn.addEventListener("click", this.openQuickShop.bind(this))
      );
  }

  async _loadQuickShop(handle) {
    let requestURL = `/products/${handle}?view=quickshop&sections=template-product-quickshop`;
    const response = await fetch(requestURL);
    const quickShopData = await response.json();
    return quickShopData["template-product-quickshop"];
  }

  /**
   * Open QuickShop modal and add focus to modal container
   *
   * @param {event} Event instance
   */
  openQuickShop(event) {
    event.preventDefault();
    console.log("click");
    const _this = event.currentTarget;
    const handle = _this.dataset.handle;
    console.log(handle);
    // if(!handle) return;

    this._loadQuickShop(handle).then((quickShopData) => {
      this.innerHTML = quickShopData;
      this.querySelector(".modal").classList.add("open");
      siteOverlay.prototype.showOverlay();

      if (this.querySelector(".product-title"))
        Utility.forceFocus(this.querySelector(".product-title"));
      this.closeBy = this.querySelector(".close-quickshop");
      if (this.closeBy)
        this.closeBy.addEventListener("click", this.closeQuickShop.bind(this));
      Utility.trapFocus(this, this.closeBy);

      if (event) {
        _this.setAttribute("aria-expanded", true);
      }
      this.componentProductForm();
    });

    if (BOLD && BOLD.bundles.app) {
      setTimeout(function () {
        let widgets = document.querySelectorAll(".bold-bundle-loaded");
        let widget;
        for (let i in widgets) {
          widget = widgets[i];
          if (typeof widget === "object") {
            widget.classList.remove("bold-bundle-loaded");
            widget.innerHTML = "";
          }
        }

        window.BOLD.bundles.app.widgets = {};
        window.BOLD.bundles.app.init();
      }, 500);
    }
  }

  /**
   * Open QuickShop and Remove focus from modal container
   *
   * @param {event} Event instance
   */
  closeQuickShop(event, elementToFocus = false) {
    console.log("CLicked", event);
    if (event !== undefined) {
      event.preventDefault();
      this.innerHTML = "";
      // quickShopSlider = null;
      siteOverlay.prototype.hideOverlay();
      let openByEle = document.querySelector(
        '.quickshop--button[aria-expanded="true"]'
      );
      openByEle.setAttribute("aria-expanded", false);
      Utility.removeTrapFocus(elementToFocus);
      Utility.forceFocus(openByEle);
    }
  }
}
customElements.define("quick-shop", quickShop);
